import { render, staticRenderFns } from "./AttendanceHeader.vue?vue&type=template&id=51a307e7&scoped=true"
import script from "./AttendanceHeader.vue?vue&type=script&lang=js"
export * from "./AttendanceHeader.vue?vue&type=script&lang=js"
import style0 from "./AttendanceHeader.vue?vue&type=style&index=0&id=51a307e7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a307e7",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QBtn,QTooltip,QMenu});
